import { capitalizeFirstLetter, firstLowerCase } from 'commons/utils/string.utils';
import { i18n } from 'i18next';

export const addI18nFormatters = (i18nInstance: i18n) => {
    i18nInstance.services.formatter?.add('firstLowerCase', (value: string) => firstLowerCase(value));
    i18nInstance.services.formatter?.add('capitalize', (value: string) => capitalizeFirstLetter(value));
    i18nInstance.services.formatter?.add('lowercase', (value: string) => `${value}`.toLocaleLowerCase());
    i18nInstance.services.formatter?.add('uppercase', (value: string) => `${value}`.toLocaleUpperCase());
};

export const toBcp47Locale = (language: string): string => language.replace('_', '-');
